<template>
  <div class="scroll">
    <!--导航菜单-->
    <div class="nav" :class="actAnchor ? 'navAnchor' : ''">
      <Row justify="center" type="flex" style="width: 100%; height: 84px">
        <Col style="z-index: 999" :xs="2" :sm="2" :md="2" :lg="4" :xl="4">
          <img
            style="height: 27px; margin: 9% 0px 0px -2%"
            src="../../static/img/home/logo.png"
            alt="公司logo"
            @click="skip"
            v-show="sidebar"
          />
          <img
            style="height: 27px; margin: 9% 0px 0px -2%"
            src="../../static/img/home/logo1.png"
            alt="公司logo"
            @click="skip"
            v-show="logo1"
          />
        </Col>
        <Col :xs="0" :sm="0" :md="0" :lg="6" :xl="10">
          <div class="menu_div">
            <Menu
              mode="horizontal"
              :theme="menuTheme"
              :active-name="$route.name"
              @on-select="onMenuSelect"
            >
              <!-- 首页 -->
              <Menu-Item
                :class="actAnchor ? 'navColor' : ''"
                name="contentWisdomSite"
                to="/home/content/contentWisdomSite"
              >
                首页
              </Menu-Item>
              <!-- 公司概况 -->
              <Menu-Item
                :class="actAnchor ? 'navColor' : ''"
                name="CompanyProfile"
                to="/home/AboutUs"
              >
                公司概况
              </Menu-Item>
              <!-- 企业产品 -->
              <Submenu name="Buy" :class="actAnchor ? 'navColor' : ''">
                <template slot="title"> 企业产品</template>
                <!-- 智慧工地 -->
                <Menu-Item
                  name="BuyWisdomSite"
                  :to="{ path: '/home/Buy/WisdomSite', query: { id: 1 } }"
                  >智慧工地平台</Menu-Item
                >
                <!-- AI移动巡检 -->
                <Menu-Item
                  name="inspection"
                  :to="{ path: '/home/Buy/inspection', query: { id: 7 } }"
                  >AI智能巡检</Menu-Item
                >
                <!-- 光伏清扫机器人 -->
                <Menu-Item
                  name="SolarRobot"
                  :to="{ path: '/home/Buy/SolarRobot', query: { id: 8 } }"
                  >智能机器人</Menu-Item
                >
                <!-- 实测实量 -->
                <Menu-Item
                  name="Resiliometer"
                  :to="{ path: '/home/Buy/Resiliometer', query: { id: 2 } }"
                  >实测实量管理平台</Menu-Item
                >
                <!-- 智慧展厅 -->
                <Menu-Item
                  name="VR"
                  :to="{ path: '/home/Buy/VR', query: { id: 3 } }"
                  >智慧展厅一体化解决方案</Menu-Item
                >
                <!-- VR虚拟现实 -->
                <Menu-Item
                  name="VR"
                  :to="{ path: '/home/Buy/VR', query: { id: 4 } }"
                  >VR、AR、MR</Menu-Item
                >
                <!-- 安全体验区 -->
                <Menu-Item
                  name="Quality"
                  :to="{ path: '/home/Buy/Quality', query: { id: 6 } }"
                  >智能化安全体验区</Menu-Item
                >
              </Submenu>
              <!-- 企业新闻 -->
              <Menu-Item
                :class="actAnchor ? 'navColor' : ''"
                name="NewsProfile"
                to="/home/News"
              >
                企业新闻
              </Menu-Item>
              <!-- 解决方案 -->
              <Submenu name="WisdomSite" :class="actAnchor ? 'navColor' : ''">
                <template slot="title"> 解决方案</template>
                <!-- 智慧工地解决方案 -->
                <Menu-Item name="smartsite" to="/home/smartsite"
                  >智慧工地解决方案</Menu-Item
                >
                <!-- AI移动巡检安全帽解决方案 -->
                <Menu-Item name="smartsite" to="/home/safetyhelmet"
                  >AI移动巡检安全帽解决方案</Menu-Item
                >
                <!-- 光伏清扫机器人解决方案 -->
                <Menu-Item
                  name="smartsite"
                  to="/home/solutions/PhotovoltaicCleaningRobot"
                  >智能清扫机器人解决方案</Menu-Item
                >
                <!-- 实测实量解决方案 -->
                <Menu-Item name="actualmeasurement" to="/home/actualmeasurement"
                  >实测实量解决方案</Menu-Item
                >
                <!-- 智慧展厅一体化解决方案 -->
                <Menu-Item name="smartsite" to="/home/exhibitionHall"
                  >智慧展厅一体化解决方案</Menu-Item
                >

                <!-- AI人工智能算法解决方案 -->
                <Menu-Item
                  name="artificialintelligence"
                  to="/home/artificialintelligence"
                  >AI人工智能算法解决方案</Menu-Item
                >
              </Submenu>
              <!-- 联系我们 -->
              <Menu-Item
                :class="actAnchor ? 'navColor' : ''"
                name="ContactUs"
                to="/home/ContactUs"
                >联系我们
              </Menu-Item>
            </Menu>
          </div>
        </Col>
        <Col
          :xs="{ span: 2, offset: 20 }"
          :sm="{ span: 2, offset: 20 }"
          :md="{ span: 2, offset: 20 }"
          :lg="0"
          :xl="0"
        >
          <img
            @click="drawerValue = true"
            style="margin-top: 15px; width: 48px; height: 48px"
            src="../../static/img/home/liebiao1.png"
            alt="暂无照片"
          />
        </Col>
      </Row>
    </div>
    <!--打开抽屉,里面是移动端的导航菜单【修改后和PC完全一致】-->
    <Drawer
      v-model="drawerValue"
      width="280"
      placement="left"
      :closable="false"
    >
      <div class="DrawerMenu">
        <Menu
          width="100%"
          :theme="menuTheme"
          :active-name="$route.name"
          :open-names="['Buy', 'WisdomSite']"
          @on-select="onMenuSelect"
        >
          <Menu-Item
            name="contentWisdomSite"
            to="/home/content/contentWisdomSite"
            >首页</Menu-Item
          >

          <Menu-Item name="CompanyProfile" to="/home/AboutUs"
            >公司概况</Menu-Item
          >

          <Submenu name="Buy">
            <template slot="title">企业产品</template>
            <Menu-Item
              name="BuyWisdomSite"
              :to="{ path: '/home/Buy/WisdomSite', query: { id: 1 } }"
              >智慧工地平台</Menu-Item
            >
            <Menu-Item
              name="inspection"
              :to="{ path: '/home/Buy/inspection', query: { id: 7 } }"
              >AI智能巡检</Menu-Item
            >
            <Menu-Item
              name="SolarRobot"
              :to="{ path: '/home/Buy/SolarRobot', query: { id: 8 } }"
              >智能机器人</Menu-Item
            >
            <Menu-Item
              name="Resiliometer"
              :to="{ path: '/home/Buy/Resiliometer', query: { id: 2 } }"
              >实测实量管理平台</Menu-Item
            >
            <Menu-Item
              name="VR"
              :to="{ path: '/home/Buy/VR', query: { id: 3 } }"
              >智慧展厅一体化解决方案</Menu-Item
            >
            <Menu-Item
              name="VR"
              :to="{ path: '/home/Buy/VR', query: { id: 4 } }"
              >VR、AR、MR</Menu-Item
            >
            <Menu-Item
              name="Quality"
              :to="{ path: '/home/Buy/Quality', query: { id: 6 } }"
              >智能化安全体验区</Menu-Item
            >
          </Submenu>

          <Menu-Item name="NewsProfile" to="/home/News">企业新闻</Menu-Item>

          <Submenu name="WisdomSite">
            <template slot="title">解决方案</template>
            <Menu-Item name="smartsite" to="/home/smartsite"
              >智慧工地解决方案</Menu-Item
            >
            <Menu-Item name="smartsite" to="/home/safetyhelmet"
              >AI移动巡检安全帽解决方案</Menu-Item
            >
            <Menu-Item
              name="smartsite"
              to="/home/solutions/PhotovoltaicCleaningRobot"
              >智能清扫机器人解决方案</Menu-Item
            >
            <Menu-Item name="actualmeasurement" to="/home/actualmeasurement"
              >实测实量解决方案</Menu-Item
            >
            <Menu-Item name="smartsite" to="/home/exhibitionHall"
              >智慧展厅一体化解决方案</Menu-Item
            >

            <Menu-Item
              name="artificialintelligence"
              to="/home/artificialintelligence"
              >AI人工智能算法解决方案</Menu-Item
            >
          </Submenu>

          <Menu-Item name="ContactUs" to="/home/ContactUs">联系我们</Menu-Item>
        </Menu>
      </div>
    </Drawer>
    <!--导航点击过后显示的页面-->
    <router-view></router-view>
    <!--底部-->
    <Row type="flex" justify="center" class="bot-col">
      <Col :sm="0" :xs="0" :md="0" :lg="24" :xl="24">
        <Row type="flex" justify="center">
          <Col :xs="8" :lg="2" :xl="2">
            <div style="margin: 30px 0px 0px 87px">
              <img
                style="width: 150px"
                src="../../static/img/home/logo1.png"
                alt=""
              />
              <div
                style="
                  font-size: 15px;
                  color: rgb(255, 255, 255);
                  font-family: SourceHanSansCNRegular;
                  margin-top: 20px;
                  width: 496%;
                "
              >
                南秀科技技术服务范围广泛，涵盖数字孪生平台、人工智能、集成电路、智能物联网、大数据、云计算、虚拟仿真软硬件，以及
                VR、AR、MR
                技术研发。公司将物联网、大数据与行业深度融合，为客户提供全流程数字化的管理工具和创新展示平台，助力行业效率与安全水平全面提升。
              </div>
            </div>
          </Col>
          <div
            style="
              width: 1px;
              height: 260px;
              margin: 21px 41px 0px 20%;
              background: rgba(255, 255, 255, 0.4);
            "
          ></div>
          <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'Resiliometer' }"
                  >企业产品
                </router-link>
              </p>
              <ul class="bottom__ui">
                <!-- 智慧工地平台 -->
                <li>
                  <router-link
                    :to="{ path: '/home/Buy/WisdomSite', query: { id: 1 } }"
                    >智慧工地平台</router-link
                  >
                </li>
                <!-- AI移动巡检 -->
                <li>
                  <router-link
                    :to="{ path: '/home/Buy/inspection', query: { id: 7 } }"
                    >AI智能巡检
                  </router-link>
                </li>
                <!-- 光伏清扫机器人 -->
                <li>
                  <router-link
                    :to="{ path: '/home/Buy/SolarRobot', query: { id: 8 } }"
                    >智能机器人
                  </router-link>
                </li>
                <!-- 实测实量管理平台 -->
                <li>
                  <router-link
                    :to="{ path: '/home/Buy/Resiliometer', query: { id: 2 } }"
                    >实测实量管理平台</router-link
                  >
                </li>
                <!-- VR、AR、MR -->
                <li>
                  <router-link :to="{ path: '/home/Buy/VR', query: { id: 4 } }"
                    >VR、AR、MR</router-link
                  >
                </li>
                <!-- 智能化安全体验区 -->
                <li>
                  <router-link
                    :to="{ path: '/home/Buy/Quality', query: { id: 6 } }"
                    >智能化安全体验区
                  </router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'CompanyProfile' }"
                  >关于我们
                </router-link>
              </p>
              <ul>
                <li>
                  <router-link :to="{ name: 'CompanyProfile' }"
                    >公司简介
                  </router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ name: 'NewsProfile' }"
                  >新闻资讯
                </router-link>
              </p>
              <ul>
                <li>
                  <router-link :to="{ name: 'NewsProfile' }"
                    >行业新闻
                  </router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col :xs="8" :lg="2" :xl="2">
            <div class="top-ul-li">
              <p>
                <router-link :to="{ path: '/home/WisdomSite' }"
                  >解决方案
                </router-link>
              </p>
              <ul class="bottom__ui">
                <li>
                  <router-link to="/home/smartsite"
                    >智慧工地解决方案</router-link
                  >
                </li>
                <li>
                  <router-link to="/home/safetyhelmet"
                    >AI移动巡检安全帽解决方案
                  </router-link>
                </li>
                <li>
                  <router-link to="/home/solutions/PhotovoltaicCleaningRobot"
                    >智能清扫机器人解决方案
                  </router-link>
                </li>
                <li>
                  <router-link to="/home/actualmeasurement"
                    >实测实量解决方案</router-link
                  >
                </li>
                <li>
                  <router-link to="/home/exhibitionHall"
                    >智慧展厅一体化解决方案
                  </router-link>
                </li>

                <li>
                  <router-link to="/home/artificialintelligence"
                    >AI人工智能算法解决方案
                  </router-link>
                </li>
              </ul>
            </div>
          </Col>
          <Col
            :xs="{ span: 18, offset: 4 }"
            :lg="{ span: 6, offset: 1 }"
            :xl="{ span: 6, offset: 1 }"
            style="margin-top: 20px; display: flex"
          >
            <div
              style="
                width: 1px;
                height: 260px;
                background: rgba(255, 255, 255, 0.4);
                margin: 0 0 0 5%;
              "
            ></div>
            <div class="weixin">
              <div class="wei_ding">
                <img
                  style="width: 80px"
                  src="../../static/img/home/wei_guan.jpg"
                  alt="#"
                />
                <div style="color: #ffffff">官方公众号</div>
              </div>
              <div
                style="margin-top: 30px; font-family: SourceHanSansCNRegular"
              >
                <div style="color: #fff">全国资讯热线</div>
                <div
                  style="
                    font-family: OPPOSans;
                    font-weight: 400;
                    font-size: 24px;
                    color: #1fc0ff;
                  "
                >
                  400-966-7895
                </div>
              </div>
              <div
                style="margin-top: 20px; font-family: SourceHanSansCNRegular"
              >
                <div @click="localBei()" style="color: #fff; cursor: pointer">
                  备案号: 豫ICP备17041859号-4
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col :sm="24" :xs="24" :md="24" :lg="0" :xl="0" style="margin: 0px">
        <Row type="flex" justify="center">
          <Col :sm="8" :xs="8" :md="8" :lg="0" :xl="0" class="bot-col-col">
            <img
              style="width: 150px; height: 150px"
              src="../../static/img/home/wei_guan.jpg"
              alt="#"
            />
          </Col>
          <Col :sm="8" :xs="8" :md="8" :lg="0" :xl="0" class="bot-col-col">
            <img
              style="width: 150px; height: 150px"
              src="../../static/img/home/home_guanwang.png"
              alt="#"
            />
          </Col>
        </Row>
        <Row
          type="flex"
          justify="center"
          style="margin-top: 20px; line-height: 50px"
        >
          <Col
            :sm="22"
            :xs="22"
            :md="22"
            :lg="0"
            :xl="0"
            style="display: flex; place-items: center"
          >
            <img width="28px" src="../../static/img/home/adress.png" alt="#" />
            &nbsp;
            <span style="font-size: 24px; color: white"
              >地址：郑州市郑东新区龙子湖中原数据产业大厦7层</span
            >
          </Col>
          <Col
            :sm="22"
            :xs="22"
            :md="22"
            :lg="0"
            :xl="0"
            style="display: flex; place-items: center"
          >
            <img width="28px" src="../../static/img/home/phone.png" alt="#" />
            &nbsp;
            <span style="font-size: 24px; color: white">
              客服热线：
              <a href="tel:400-9667895" style="font-size: 28px">400-9667895</a>
            </span>
          </Col>
          <Col
            :sm="22"
            :xs="22"
            :md="22"
            :lg="0"
            :xl="0"
            style="display: flex; place-items: center"
          >
            <img width="28px" src="../../static/img/home/phone.png" alt="#" />
            &nbsp;
            <span style="font-size: 24px; color: white">
              客服热线：<a href="tel:0371-55113808" style="font-size: 28px"
                >0371-55113808</a
              >
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
    <!--侧边栏-->
    <div class="outSide" v-show="sidebar">
      <div class="WeChat">
        <Poptip trigger="hover" placement="left">
          <div class="service-img">
            <img
              style="width: 32px; height: 32px"
              src="../../static/img/home/WeChat.png"
              alt="#"
            />
          </div>
          <div
            style="
              font-size: 12px;
              font-family: 'Microsoft YaHei', serif;
              color: #000;
            "
          >
            微信咨询
          </div>
          <div slot="content">
            <img
              style="width: 128px; height: 128px"
              src="../../static/img/home/code.png"
              alt="#"
            />
          </div>
        </Poptip>
      </div>
      <div class="WeChat">
        <Poptip trigger="hover" placement="left">
          <div class="service-img">
            <img
              style="width: 32px; height: 32px"
              src="../../static/img/home/WeChat.png"
              alt="#"
            />
          </div>
          <div
            style="
              font-size: 12px;
              font-family: 'Microsoft YaHei', serif;
              color: #000;
            "
          >
            微信公众号
          </div>
          <div slot="content">
            <img
              style="width: 128px; height: 128px"
              src="../../static/img/home/wei_guan.jpg"
              alt="#"
            />
          </div>
        </Poptip>
      </div>
    </div>
    <!--返回顶部-->
    <BackTop
      :height="100"
      :bottom="50"
      style="background-color: #000"
    ></BackTop>
  </div>
</template>
<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      /*抽屉*/
      drawerValue: false,
      /*表单*/
      formItem: {
        userName: "",
        email: "",
        phone: "",
        message: "",
        code: "",
      },
      ruleItem: {},
      /*验证码*/
      show_num: [],
      /*-----*/
      dialog: false,
      actAnchor: false,
      menuTheme: "light",
      CarouselVal: 0,
      /*客服聊天*/
      arr: [
        { person: "A", words: "" },
        { person: "B", words: "" },
      ],
      str1: "0",
      str2: "",
      sidebar: false,
      logo1: true,
    };
  },
  mounted() {
    //监听滚动事件
    window.addEventListener("scroll", this.OnScroll, false);
  },
  destroyed() {
    //移除滚动事件
    window.removeEventListener("scroll", this.OnScroll);
  },
  methods: {
    /*跳转到工信备案网站*/
    localBei() {
      window.open("https://beian.miit.gov.cn");
    },
    /*跳转买商品*/
    getMoney(item) {
      this.$router.push({
        path: "/buyGo",
        query: {
          money: item.money,
          ref: item.ref,
          photoUrl1: item.photoUrl1,
        },
      });
    },
    /*打开微博*/
    windowOpen() {
      window.open("https://weibo.com/u/6004822810");
    },
    //*弹出客服聊天*/
    getChitIcon() {
      this.dialog = false;
    },
    /*聊天*/
    add_data() {
      // bug: 内容不能为空。
      if (this.str2.trim() === "") {
        this.$Message.info("内容不能为空");
        this.str2 = "";
        return;
      }
      var p = this.str1 === "0" ? "A" : "B";
      var obj = { person: p, words: this.str2 };
      this.arr.push(obj);
      // 添加完内容，清空
      this.str2 = "";
    },
    /*弹出对话框*/
    ModalService() {
      this.dialog = true;
    },
    /*滚动事件*/
    OnScroll() {
      let _this = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 90) {
        _this.actAnchor = scrollTop > 90;
        _this.sidebar = true;
        _this.logo1 = false;
      } else {
        _this.actAnchor = scrollTop > 90;
        _this.sidebar = false;
        _this.logo1 = true;
      }
    },
    /*导航菜单点击事件*/
    onMenuSelect() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.drawerValue = false;
    },
    skip() {
      this.$router.push({ path: "/home/content/contentWisdomSite" });
    },
  },
};
</script>
<style scoped>
/*导航*/
.nav {
  width: 100%;
  position: absolute;
}
.menu_div {
  width: 850px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  margin-right: 10%;
  font-family: OPPOSansRegular;
}
.ivu-menu-light {
  background: initial;
}
.menu_div /deep/ .ivu-menu-horizontal.ivu-menu-light:after {
  height: 0;
}
.menu_div /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu i {
  display: none;
}
.menu_div /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.menu_div /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  font-size: 18px;
  color: #fff;
}
/deep/ .ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-horizontal .ivu-menu-submenu {
  padding: 0px 30px;
}
.menu_div
  .ivu-menu-horizontal
  .ivu-menu-submenu
  .ivu-select-dropdown
  .ivu-menu-item {
  font-size: 16px !important;
  line-height: 32px;
}
/*抽屉导航*/
.DrawerMenu {
  padding-top: 20px;
}
.DrawerMenu /deep/ .ivu-menu-vertical.ivu-menu-light .ivu-menu-item,
.DrawerMenu /deep/ .ivu-menu-vertical.ivu-menu-light .ivu-menu-submenu-title {
  font-size: 18px;
}
.DrawerMenu /deep/ .ivu-menu-vertical.ivu-menu-light:after {
  height: 0;
}
/*------------导航吸顶-------------*/
.header {
  width: 100%;
  height: 90px;
  background: #eeeeee;
}
.navAnchor {
  position: fixed;
  top: 0;
  z-index: 999;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
  color: #333333 !important;
}
/*---------------------------*/
/*---------侧边栏----------*/
.outSide {
  width: 64px;
  height: 140px;
  background: #fff;
  color: white;
  font-family: "Microsoft YaHei", serif;
  font-size: 8px;
  position: fixed;
  _position: relative;
  right: 25px;
  top: 600px;
  z-index: 999;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
.service {
  padding-top: 8px;
  width: 100%;
  height: 70px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}
.Weibo {
  padding-top: 8px;
  width: 100%;
  height: 70px;
  cursor: pointer;
}
.WeChat {
  width: 100%;
  height: 70px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.service div,
.WeChat div,
.Weibo div {
  text-align: center;
}
.WeChat:hover,
.service:hover,
.Weibo:hover {
  background: #585a5a;
}
.service-img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.service img {
  width: 32px;
  height: 32px;
}
.Weibo img {
  width: 32px;
  height: 32px;
}
/*-----------------------------*/
/*--------------客服聊天----------------------*/
.chitchat {
  width: 400px;
  height: 500px;
  position: fixed;
  _position: relative;
  right: 14px;
  top: 420px;
  z-index: 9999;
  border-radius: 14px;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.16);
}
.chit-icon {
  position: absolute;
  top: 2px;
  right: 4px;
}
.chit-top {
  width: 400px;
  height: 60px;
  background: #02a0e7;
  border-radius: 14px 14px 0 0;
}
.talk_show {
  width: 400px;
  height: 350px;
  background: #fafdff;
  overflow: auto;
}
.talk_input {
  width: 400px;
  height: 100px;
  background: #dddddd;
  border-radius: 0 0 14px 14px;
  display: flex;
}
/*谁说话*/
.whotalk {
  width: 60px;
  height: 100px;
  outline: none;
  border-radius: 0 0 0 14px;
  border: none;
  background: #eeeeee;
}
/*询问问题*/
.talk_word {
  width: 260px;
  height: 100px;
  padding: 4px 0 0 0;
  outline: none;
  text-indent: 4px;
  resize: none;
  /*border-radius: 0 0 0 14px;*/
  border: none;
  color: #666666;
  font-family: "Microsoft YaHei", serif;
}
/*发送信息*/
.talk_sub {
  width: 80px;
  height: 100px;
  background: #eeeeee;
  padding: 36px 0 0 10px;
  border-radius: 0 0 14px 0;
}
.atalk {
  margin: 10px;
}
.atalk span {
  display: inline-block;
  background: #e7eeed;
  border-radius: 10px;
  color: black;
  padding: 5px 10px;
}
.btalk {
  margin: 10px;
  text-align: right;
}
.btalk span {
  display: inline-block;
  background: #02a0e7;
  border-radius: 10px;
  color: #fff;
  padding: 5px 10px;
}
/*--------------------------------------------*/
/*--------------底部--------------------------*/
@media screen and (max-width: 567px) {
  .top-ul-li1 ul li {
    font-size: 26px;
  }
}
.top-ul-li {
  margin: 20px 0px 0px 0;
  text-align: center;
  width: 178px;
}
.top-ul-li p {
  font-size: 16px;
  color: #fff;
  font-family: SourceHanSansCNRegular;
  /* border-left: 1px solid #ffffff; */
}
.top-ul-li ul {
  color: #afaeb3;
  list-style-type: none;
  text-align: center;
  line-height: 23px;
  position: relative;
  top: 15px;
}
.bottom__ui li {
  width: 152px;
  font-size: 14px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  color: #999999;
  line-height: 40px;
  width: 184px;
}
.top-ul-li a {
  color: white;
}
.top-ul-li ul li a {
  color: #afaeb3;
  font-size: 15px;
}
.top-ul-li ul li a:hover,
.top-ul-li1 ul li:hover {
  color: white;
  cursor: pointer;
}
.top-ul-li1 {
  width: 100%;
  height: 100%;
  /* margin: 20px 0 0 0; */
  text-align: center;
}
.top-ul-li1 ul {
  color: #afaeb3;
  list-style-type: none;
  line-height: 56px;
  position: relative;
  top: 6px;
}
.top-ul-li1 ul li {
  display: inline-block;
  padding: 0 5px;
  cursor: pointer;
}
.weixin {
  margin: 5%;
}
@media screen and (max-width: 567px) {
  .top-ul-li ul {
    line-height: 96px;
  }
  .weixin {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.wei_ding {
  cursor: pointer;
  font-family: SourceHanSansCNRegular;
}
.bot-col {
  background-image: url("../../static/img/home/bottom_img.png");
  background-size: 100% 100%;
  height: 395px;
}
.bot-col-col {
  display: grid;
  place-items: center;
  margin-top: 20px;
}
/*---------------------------------------------*/
/* a {
  color: #222;
} */
.top_ul li {
  float: left;
  padding-left: 60px;
  font-size: 17px;
}
.logo__ {
  height: 25px;
  margin: 26px 0px 0px 30%;
  cursor: pointer;
}
.logo__title {
  position: absolute;
  margin-top: 6%;
  width: 300px;
  height: 22px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 52px;
}
.navColor {
  color: #333333 !important;
}
/deep/ .ivu-menu-drop-list .ivu-menu-item {
  color: #333333 !important;
}
/deep/ .svg-icon {
  width: 150px;
  vertical-align: -2.5em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue